import {useEffect, useRef, useState} from 'react';
import {Button, Dialog, Portal} from '@chakra-ui/react';
import {PlazmaCopiesOption} from './PlazmaCopiesOption';

interface ConfirmArchiveDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (alsoRemovePlazmaCopies: boolean) => void;
    count: number;
    /** Number of the files to archive that also have a plazma copy. */
    plazmaStarredCount: number;
    /** The user may not delete those plazma copies, so removing them can't be chosen. */
    plazmaCopiesForbidden?: boolean;
    isArchiving?: boolean;
}

/** Only shown when archiving web photos that are also in plazma; plain archiving needs no confirmation. */
export function ConfirmArchiveDialog({
    isOpen,
    onClose,
    onConfirm,
    count,
    plazmaStarredCount,
    plazmaCopiesForbidden = false,
    isArchiving,
}: ConfirmArchiveDialogProps) {
    const cancelRef = useRef<HTMLButtonElement>(null);
    const [removePlazmaCopies, setRemovePlazmaCopies] = useState(false);

    // Default to leaving plazma copies alone every time the dialog opens.
    useEffect(() => {
        if (isOpen) setRemovePlazmaCopies(false);
    }, [isOpen]);

    return <Dialog.Root
        role="alertdialog"
        open={isOpen}
        onOpenChange={(e) => {
            if (!e.open) onClose();
        }}
        initialFocusEl={() => cancelRef.current}
    >
        <Portal>
            <Dialog.Backdrop/>
            <Dialog.Positioner>
            <Dialog.Content>
                <Dialog.Header><Dialog.Title>Archívumba helyezed {count > 1 ? `ezt a ${count} fájlt` : 'a fájlt'}?</Dialog.Title></Dialog.Header>
                <Dialog.Body>
                    <PlazmaCopiesOption
                        fileCount={count}
                        starredCount={plazmaStarredCount}
                        action="remove"
                        checked={removePlazmaCopies}
                        onChange={setRemovePlazmaCopies}
                        removeForbidden={plazmaCopiesForbidden}
                    />
                </Dialog.Body>
                <Dialog.Footer gap={0}>
                    <Button ref={cancelRef} variant="subtle" onClick={onClose}>Mégse</Button>
                    <Button colorPalette="blue" onClick={() => onConfirm(removePlazmaCopies && !plazmaCopiesForbidden)} ml={3} loading={isArchiving}>
                        Archívumba
                    </Button>
                </Dialog.Footer>
            </Dialog.Content>
            </Dialog.Positioner>
        </Portal>
    </Dialog.Root>;
}
